import { render, staticRenderFns } from "./jkzwDetail.vue?vue&type=template&id=042d8af6&scoped=true&"
import script from "./jkzwDetail.vue?vue&type=script&lang=js&"
export * from "./jkzwDetail.vue?vue&type=script&lang=js&"
import style0 from "./jkzwDetail.vue?vue&type=style&index=0&id=042d8af6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042d8af6",
  null
  
)

export default component.exports